import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { decode } from 'js-base64';
import { NotificationCard } from '../components/Card';
import { NotificationTime } from '../components/Time';
import { WarningNotification } from '@/assets/icons/notification';
import { NotificationLink } from '../components/NotificationLink';

export const FlowStoppedForCandidates = ({
  notification = {},
  onClose = () => {},
}) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));

  return (
    <NotificationCard notification={notification}>
      <Flex pl="12px">
        <Icon as={WarningNotification} width="40px" height="40px" />
        <Box ml="12px">
          <Text mb="12px">
            <Text as="span" pr="4px">
              {data?.count}
            </Text>
            candidates have been Stopped in Flow
            <NotificationLink
              to={`/flows/${data?.outreach_id}`}
              label={data?.outreach_name}
              onClose={onClose}
              notification={notification}
              data-test-id="flow-link"
            />
            automatically
          </Text>
          <Flex alignItems="center" gap="12px" flexDir="row-reverse">
            <NotificationTime notification={notification} />
          </Flex>
        </Box>
      </Flex>
    </NotificationCard>
  );
};
